/* 🤖 this file was generated by svg-to-ts */
export const matIconSwitchRight: {
  name: 'switch-right';
  data: string;
} = {
  name: 'switch-right',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M15.5 15.38V8.62L18.88 12l-3.38 3.38M14 19l7-7-7-7v14zm-4 0V5l-7 7 7 7z"/></svg>`
};
